<template>
  <div class="ws-modal">
    <form class="ws-modal__form" @submit.prevent="submit">
      <header class="ws-modal__header">
        <h2 class="has-text-weight-bold is-size-1">
          <span v-if="!isNewItem" v-text="$t('Редактировать экзамен')"></span>
          <span v-else v-text="$t('Создать новый экзамен')"></span>
        </h2>
      </header>
      <div class="ws-modal__content" :class="{'is-loading':isPending}">
        <div class="columns is-multiline">
          <div class="column is-12" v-if="!isNewItem">
            <b-field class="ws-field is-required"
                     :label="$t('Название экзамена')"
                     :type="{'is-danger': errors.has('name')}"
                     :message="errors.first('name')">
              <b-input class="ws-field__control"
                       v-model="newItem.name.translate.ru"
                       v-validate="{ required: true }"
                       :data-vv-as="$t('Название экзамена')"
                       name="name"
              />
            </b-field>
          </div>
          <div class="column is-8">
            <b-field class="ws-field"
                     :label="$t('Профессия/специальность (ДЭ)')"
                     :type="{'is-danger': errors.has('competence')}"
                     :message="errors.first('competence')">
              <ws-refbook-field
                entity="competence"
                field="name.display"
                name="competence"
                :guid.sync="competence.guid"
                :item.sync="competence.item"
                v-model="competence.value"
                :query="{wo_skill: true}"
                @change="selectCompetence"
                :disabled="isCompetenceDisable"
                v-validate="{ required: true, selected: competence.guid }"
                :data-vv-as="$t('Профессия/специальность (ДЭ)')"
                :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-2">
            <b-field class="ws-field"
                     :label="$t('Сложность')"
                     :type="{'is-danger': errors.has('acc')}"
                     :message="errors.first('acc')">
              <WsSelectComplexityCode
                  class="ws-field__control"
                  :disabled="!competence.item.guid"
                  name="acc"
                  v-validate="{ required: true }"
                  :value="newItem.accred_comps.complexity_level"
                  :data-vv-as="$t('Сложность')"
                  :placeholder="$t('')"
                  expanded
                  open-on-focus
                  :onChange="onChangeComplexy"
              />
            </b-field>
          </div>
          <div class="column is-2">
            <b-field class="ws-field" :label="$t('Наличие КОД')">
              <b-input class="ws-field__control"
                       disabled
                       :value="isHasCod() ? $t('Есть') : $t('Нет')"
                       :data-vv-as="$t('Наличие КОД')"
                       :placeholder="$t('')" />
            </b-field>
          </div>
          <div class="column is-4">
            <b-field class="ws-field"
                     :label="$t('Дата проведения')"
                     :type="{'is-danger': errors.has('day_cm1')}"
                     :message="errors.first('day_cm1')">
              <ws-datepicker
                v-validate="{ required: true, correctDate: true }"
                v-model="day_cm1"
                :data-vv-as="$t('День ПД')"
                name="day_cm1"
                @input="onSelectDaycm1"
                :focused-date="nextMonth"
                class="ws-field__control">
              </ws-datepicker>
            </b-field>
          </div>
          <div class="column is-8">
            <b-field class="ws-field"
                     :label="$t('Образовательная Организация')"
                     :type="{'is-danger': errors.has('institution')}"
                     :message="errors.first('institution')">
              <ws-refbook-field
                entity="public/refbook/education/institution"
                field="title.display"
                name="institution"
                :guid.sync="institution.guid"
                :item.sync="institution.item"
                v-model="institution.value"
                @change="selectInstitution"
                v-validate="{ required: true, selected: institution.guid }"
                :data-vv-as="$t('ОО')"
                :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
                <template
                    slot="item"
                    slot-scope="props"
                >
                  <p>
                    <ws-icon v-if="props.option.visible === false" name="stop" color="red" class="icon-stop" width="15" height="15"/>
                    {{ props.option.title.display }}
                  </p>
                </template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column">
            <b-field class="ws-field"
                     :label="$t('Программа обучения')"
                     :type="{'is-danger': errors.has('study_group')}"
                     :message="errors.first('study_group')">
              <ws-refbook-field
                :disabled="!institution.guid"
                entity="refbook/study_groups"
                field="name"
                name="study_group"
                :guid.sync="study_group.guid"
                :item.sync="study_group.item"
                :list.sync="study_group.list"
                v-model="study_group.value"
                :query="{education_guid: institution.guid, education_year: new Date().getFullYear()}"
                @change="selectStudyGroup"
                v-validate="{ required: true }"
                :data-vv-as="$t('Программа обучения')"
                :isFocus="true">
                <template slot="empty" v-text="$t('Ничего не найдено')"></template>
              </ws-refbook-field>
            </b-field>
          </div>
          <div class="column is-12">
            <p v-text="$t('Импорт участников')"></p>
            <b-field v-if="users.length === 0" class="ws-field">
              <ws-participants-import
                format="xlsx"
                name="users"
                @input-users="onImportUsers"></ws-participants-import>
            </b-field>
            <div v-else>
              Импортировано {{users.length}} Участников
            </div>
          </div>
        </div>
      </div>
      <footer class="ws-modal__footer">
        <div class="columns">
          <div class="column is-8"></div>
          <div class="column is-4 is-vcentered">
            <div class="has-text-right-desktop">
              <button class="ws-button button is-large is-primary is-fullwidth" :class="{'is-loading':isPending}">
                <span class="is-size-4 has-text-weight-bold" v-if="!isNewItem" v-text="$t('Редактировать')"></span>
                <span class="is-size-4 has-text-weight-bold" v-else v-text="$t('Создать')"></span>
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
    <aside class="ws-modal__sidebar">
      <button class="ws-button button is-text"
              @click="close">
        <ws-icon
          class="ws-button__icon"
          name="close-thin"
          color="#000000"
          :fill="true"
          :title="$t('Закрыть')"
          width="17"
          height="18"
        />
      </button>
    </aside>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import computedDateProp from '@/utils/computedDateProp'
import moment from 'moment'
import WsDatepicker from '@/components/common/WsDatepicker'
import { constants } from '@/services/constants.service'
const getNextDay = function (date) {
  const day = moment(new Date(date))
  const daysToAdd = day.weekday() === 5 ? 2 : 1
  return day.weekday(day.weekday() + daysToAdd)
}
export default {
  name: 'WsExamsForm',
  components: { WsDatepicker },
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          name: {
            translate: {
              ru: ''
            }
          },
          institution: {
            guid: null,
            title: {
              translate: {
                ru: ''
              }
            }
          },
          de_center: {
            guid: null,
            title: {
              translate: {
                ru: ''
              }
            }
          },
          accred_comps: {
            number: null,
            competency: {
              code: null,
              guid: null,
              name: {
                translate: {
                  ru: ''
                }
              }
            },
            status: null,
            complexity_level: null
          },
          day_cm1: null,
          started_at: null,
          ended_at: null,
          flags: [],
          complexity_level: null,
          status: 'new'
        }
      }
    }
  },
  data () {
    return {
      institution: {
        value: '',
        guid: null,
        list: []
      },
      deCenter: {
        value: '',
        guid: null,
        list: []
      },
      competence: {
        value: '',
        guid: null,
        item: null,
        list: []
      },
      newItem: this.item,
      nextMonth: moment().add(1, 'M').toDate(),
      users: [],
      program: {
        title: {
          translate: {
            ru: null
          }
        },
        value: '',
        guid: null,
        item: null,
        list: []
      },
      study_group: {
        name: '',
        value: '',
        guid: null,
        item: null,
        list: []
      },
      isPending: false,
      constants
    }
  },
  watch: {
    item: {
      immediate: true,
      // deep: true,
      handler (item) {
        if (item) {
          this.deCenter.guid = this.newItem.de_center.guid
          this.competence.guid = this.newItem.accred_comps.competency.guid
          this.competence.item = this.newItem.accred_comps.competency
          if (this.newItem.de_center && this.newItem.de_center.name && this.newItem.de_center.name.display) {
            this.deCenter.value = this.newItem.de_center.name.display
          }
          if (this.newItem.accred_comps.competency && this.newItem.accred_comps.competency.name && this.newItem.accred_comps.competency.name.display) {
            this.competence.value = this.newItem.accred_comps.competency.name.display
          }
          this.newItem = Object.assign({}, item)
        }
      }
    }
  },
  computed: {
    ...mapState('authentication', ['currentRole']),
    isNewItem () {
      return !(this.newItem && this.newItem.guid)
    },
    isCompetenceDisable () {
      return !!(this.newItem && ((this.newItem.experts && this.newItem.experts.length) || this.newItem.main_expert))
    },
    day_cm1: computedDateProp('newItem', 'day_cm1'),
    started_at: computedDateProp('newItem', 'started_at'),
    ended_at: computedDateProp('newItem', 'ended_at')
  },
  mounted () {
    this.$validator.pause()
    switch (this.currentRole) {
      case 'front_50plus':
        this.newItem.flags = ['50_plus']
        break
      case 'front_mio':
        this.newItem.flags = ['master_of_industrial_edu']
        break
      default:
        this.newItem.flags = []
    }
  },
  methods: {
    ...mapActions('exams', ['create', 'update', 'updateParticipantsList', 'createShift']),
    ...mapActions('exams/shifts', {
      createGroup: 'create'
    }),
    ...mapActions('based/de-center', {
      createDeCenterBased: 'create'
    }),
    ...mapActions('refbook/study_groups', {
      createStudyGroup: 'create'
    }),
    onChangeComplexy (option) {
      this.newItem = {
        ...this.newItem,
        accred_comps: {
          ...this.newItem.accred_comps,
          complexity_level: option
        }
      }
    },
    onSelectDaycm1 (date) {
      this.started_at = date
      this.ended_at = date
    },
    async selectCompetence (competence) {
      if (competence) {
        this.newItem.accred_comps.competency = competence
      }
    },
    selectInstitution (institution) {
      if (institution) {
        this.institution.guid = institution.guid
      }
    },
    selectStudyGroup (studyGroup) {
      if (studyGroup) {
        this.study_group.guid = studyGroup.guid
      }
    },
    onImportUsers (users) {
      if (users && users.length) {
        this.users = users.map(u => u.guid)
      }
    },
    isHasCod () {
      if (this.competence.item && this.competence.item.complexity_level && this.competence.item.complexity_level.length) {
        return this.competence.item.complexity_level.indexOf(this.newItem && this.newItem.accred_comps && this.newItem.accred_comps.complexity_level) > -1
      } else {
        return false
      }
    },
    async submit () {
      this.$validator.resume()
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.isPending = true
          delete this.newItem.accred_comps.guid
          if (this.isNewItem) {
            const newExamForm = Object.assign({}, this.newItem)
            let dayCm1 = new Date(newExamForm.day_cm1)
            newExamForm.day_cm1 = new Date(dayCm1.setDate(dayCm1.getDate() - 1))
            const normalizedStartDate = moment(newExamForm.started_at).format('D.MM.YYYY')
            const complexityLevel = newExamForm.accred_comps.complexity_level ? `${newExamForm.accred_comps.complexity_level} ` : ''
            newExamForm.name.translate.ru = `${normalizedStartDate} ${complexityLevel}${newExamForm.accred_comps.competency.name.translate.ru}`

            const deCenter = await this.createDeCenterBased([{}, `/institution/${this.institution.guid}/de-centers`])
            newExamForm.de_center.guid = deCenter.guid

            try {
              let newStudyGroup = {}
              let studyGroupGuid = this.study_group.guid
              if (!studyGroupGuid) {
                const studyGroupFromList = this.study_group.list.find(s => s.name === this.study_group.value)
                if (studyGroupFromList) {
                  studyGroupGuid = studyGroupFromList.guid
                }
              }
              if (studyGroupGuid) {
                newStudyGroup.guid = studyGroupGuid
              } else {
                newStudyGroup = await this.createStudyGroup({
                  university: {
                    guid: this.institution.guid
                  },
                  name: this.study_group.value,
                  education_year: new Date().getFullYear()
                })
              }

              const newExam = await this.create(newExamForm)

              // Create shift
              newExamForm.shift = await this.createShift({
                'examGuid': newExam.guid,
                data: {
                  'number': 1,
                  'job_issued_at': this.newItem.day_cm1,
                  'started_at': getNextDay(this.newItem.day_cm1),
                  'ended_at': getNextDay(this.newItem.day_cm1)
                }
              })

              // Create group
              const group = await this.createGroup([{
                'shift': {
                  'guid': newExamForm.shift.guid
                },
                'student': this.users && this.users.length ? this.users.length : 0,
                'education_group': {
                  guid: newStudyGroup.guid
                }
              }, `/${newExam.guid}/shifts/${newExamForm.shift.guid}/groups` ])

              if (this.users.length) {
                await this.updateParticipantsList({
                  params: {
                    examGuid: newExam.guid,
                    shiftGuid: newExamForm.shift.guid,
                    groupGuid: group.guid
                  },
                  data: {
                    update: this.users
                  }
                })
              }

              await this.update([newExam.guid, [], `/status/agreed`])

              this.$emit('editExam', newExam)

              this.$buefy.toast.open({
                message: this.$t(`Экзамен ${newExamForm.name.translate.ru} успешно создан.`),
                type: 'is-success'
              })
            } catch (e) {
              this.$buefy.toast.open({
                message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
                type: 'is-danger'
              })
            }
          } else {
            await this.update([this.newItem.guid, this.newItem])
            this.$emit('editExam', this.newItem)
            this.$buefy.toast.open({
              message: this.$t(`Экзамен ${this.newItem.name.translate.ru} успешно обновлен.`),
              type: 'is-success'
            })
          }
          this.isPending = false
          this.$parent.close()
        }
      })
    },
    close () {
      this.$parent.close()
    }
  }
}
</script>
